import FilterRemoveButton from './FilterRemoveButton'
export default FilterRemoveButton



// WEBPACK FOOTER //
// ./src/components/FilterRemoveButton/index.js